export const STATUS_FLAGS = {
  FALSE: 'false',
  TRUE: 'true',
}
